// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InvitationRead } from "./InvitationRead";
import {
  InvitationReadFromJSON,
  InvitationReadFromJSONTyped,
  InvitationReadToJSON,
  InvitationReadToJSONTyped,
} from "./InvitationRead";

/**
 *
 * @export
 * @interface PageInvitationRead
 */
export interface PageInvitationRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<InvitationRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageInvitationRead interface.
 */
export function instanceOfPageInvitationRead(value: object): value is PageInvitationRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageInvitationReadFromJSON(json: any): PageInvitationRead {
  return PageInvitationReadFromJSONTyped(json, false);
}

export function PageInvitationReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageInvitationRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(InvitationReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageInvitationReadToJSON(json: any): PageInvitationRead {
  return PageInvitationReadToJSONTyped(json, false);
}

export function PageInvitationReadToJSONTyped(
  value?: PageInvitationRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(InvitationReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
